export const SUPABASE_PROXY_SETTING_KEY = 'supabaseProxy';

/** Preferencja trybu połączenia — odczyt przy starcie panelu (przed utworzeniem klienta Supabase). */
export const SUPABASE_PROXY_STORAGE_KEY = 'admin_supabase_proxy_enabled';

export function isProxyEnvAvailable() {
  return !!process.env.REACT_APP_SUPABASE_PROXY_URL?.trim();
}

export function isDirectEnvAvailable() {
  return !!(
    process.env.REACT_APP_SUPABASE_URL?.trim() && process.env.REACT_APP_SUPABASE_ANON_KEY?.trim()
  );
}

/** Domyślnie: proxy, jeśli skonfigurowane w .env (jak dotychczas na Vercel). */
export function getDefaultProxyEnabled() {
  if (isProxyEnvAvailable()) return true;
  if (isDirectEnvAvailable()) return false;
  return true;
}

export function readProxyEnabledFromStorage() {
  if (typeof window === 'undefined') return getDefaultProxyEnabled();
  const stored = localStorage.getItem(SUPABASE_PROXY_STORAGE_KEY);
  if (stored === 'true') return true;
  if (stored === 'false') return false;
  return getDefaultProxyEnabled();
}

export function writeProxyEnabledToStorage(enabled) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(SUPABASE_PROXY_STORAGE_KEY, enabled ? 'true' : 'false');
}
